// Assets
import black from "assets/images/finnsrec/black.png"
import white from "assets/images/finnsrec/white.png"
import logo from 'assets/images/logo.png' 
import special from 'assets/images/special.svg' 
import ultimate from 'assets/images/ultimate.webp' 

const finnsrec = { black, white }

export { finnsrec, logo, special, ultimate }